/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Map Pin Icon component.
 */
export const MapPinIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z' fill={iconColor} />
      <path d='M12 18H14V13H16V9C16 7.897 15.103 7 14 7H10C8.897 7 8 7.897 8 9V13H10V18H12Z' fill={iconColor} />
      <path d='M18.446 11.386L17.553 13.175C19.108 13.95 20 14.98 20 16C20 17.892 16.715 20 12 20C7.285 20 4 17.892 4 16C4 14.98 4.892 13.95 6.446 13.175L5.553 11.386C3.295 12.512 2 14.193 2 16C2 19.364 6.393 22 12 22C17.607 22 22 19.364 22 16C22 14.193 20.705 12.512 18.446 11.386Z' fill={iconColor} />
    </svg>
  );
};

export default MapPinIcon;
